import {
  ContainerScroll,
  BentoGrid,
  BentoCell,
  ContainerScale,
} from "./ui/HeroGalleryScrollAnimation";
import { Button } from "./ui/Button";

const IMAGES = [
  "https://images.unsplash.com/photo-1626785774573-4b799315345d?w=800&auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1558655146-9f40138edfeb?w=800&auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=800&auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1634986666676-ec8fd927c23d?w=800&auto=format&fit=crop&q=80",
];

function Hero() {
  return (
    <ContainerScroll className="h-[350vh]">
      <BentoGrid className="sticky left-0 top-0 z-0 h-screen w-full p-4">
        {IMAGES.map((imageUrl, index) => (
          <BentoCell
            key={index}
            className="overflow-hidden rounded-xl shadow-xl"
          >
            <img
              className="size-full object-cover object-center"
              src={imageUrl}
              alt={`Studio Form project ${index + 1}`}
            />
          </BentoCell>
        ))}
      </BentoGrid>

      <ContainerScale className="relative z-10 text-center">
        <p className="text-sm uppercase tracking-[0.3em] text-gray-400 mb-4">
          Studio Form
        </p>
        <h1 className="max-w-xl text-4xl sm:text-5xl md:text-7xl font-bold tracking-tighter text-primary">
          Diseño gráfico que comunica
        </h1>
        <p className="my-6 max-w-xl text-base md:text-lg text-gray-500 leading-relaxed">
          Creamos identidades visuales que conectan marcas con personas.
          Estrategia, diseño y ejecución — en su forma más pura.
        </p>
        <div className="flex items-center justify-center gap-4">
          <Button className="bg-primary px-6 py-2 font-medium hover:bg-accent">
            Ver Trabajos
          </Button>
          <Button
            variant="link"
            className="bg-transparent px-6 py-2 font-medium"
          >
            Contacto
          </Button>
        </div>
      </ContainerScale>
    </ContainerScroll>
  );
}

export default Hero;
